import { render, staticRenderFns } from "./CourseCodeAssignmentView.vue?vue&type=template&id=177a422d&scoped=true"
import script from "./CourseCodeAssignmentView.vue?vue&type=script&lang=js"
export * from "./CourseCodeAssignmentView.vue?vue&type=script&lang=js"
import style0 from "./CourseCodeAssignmentView.vue?vue&type=style&index=0&id=177a422d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a422d",
  null
  
)

export default component.exports